const Home = () => {
    return (
        <div className="container">
            <h1>Privacy Policy</h1>
            <p><strong>Effective Date:</strong> 03.17.2025</p>

            <h2>1. Introduction</h2>
            <p>Welcome to CryptoGood! Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our mobile application (the "App"). By using the App, you agree to the collection and use of information as described in this policy.</p>

            <h2>2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
                <li><strong>Personal Information:</strong> When you create an account, we may collect your name, email address, and other necessary details.</li>
                <li><strong>Usage Data:</strong> Information about how you interact with the App, including features used and time spent.</li>
                <li><strong>Device Information:</strong> Details such as device type, operating system, and IP address.</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>We use your information for the following purposes:</p>
            <ul>
                <li>To provide, maintain, and improve the App.</li>
                <li>To personalize your experience and offer relevant content.</li>
                <li>To communicate important updates, security alerts, or promotional materials.</li>
                <li>To comply with legal obligations.</li>
            </ul>

            <h2>4. Sharing and Disclosure</h2>
            <p>We do not sell or rent your personal information. However, we may share your data in the following cases:</p>
            <ul>
                <li><strong>Service Providers:</strong> We may share information with trusted third-party service providers to support our App's functionality.</li>
                <li><strong>Legal Requirements:</strong> If required by law or to protect the rights and safety of CryptoGood and its users.</li>
                <li><strong>Business Transfers:</strong> In case of a merger, acquisition, or sale of assets, your information may be transferred.</li>
            </ul>

            <h2>5. Data Security</h2>
            <p>We implement industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>

            <h2>6. Your Rights and Choices</h2>
            <p>Depending on your location, you may have rights regarding your personal information, including access, correction, deletion, and opting out of certain data processing. You can contact us at <strong>contact@drixylabs.com</strong> to exercise your rights.</p>

            <h2>7. Third-Party Links and Services</h2>
            <p>Our App may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties.</p>

            <h2>8. Children's Privacy</h2>
            <p>The App is not intended for individuals under the age of 13, and we do not knowingly collect personal data from children.</p>

            <h2>9. Changes to This Privacy Policy</h2>
            <p>We may update this policy from time to time. Any changes will be posted within the App, and continued use after changes take effect constitutes acceptance of the updated policy.</p>

            <h2>10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at <strong>contact@drixylabs.com</strong>.</p>
        </div>
    );
};

export default Home;
